export const ROUTES = {
  homePage: {
    path: '/',
  },
  adminPage: {
    path: '/admin',
  },
};
